import { Box, Divider, Typography, useTheme } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import RenderHTML from '../../../components/preview/RenderHTML';
import { useTranslation } from 'react-i18next';
import { SalesObjectLevelText } from './SalesObjectLevelText';
import { SalesObjectLevelImages } from './SalesObjectLevelImages';

export const SalesObjectLevel = ({ data, onChange }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const { t } = useTranslation();

  console.log(data);
  const { title, description, id, images } = data;

  return (
    <Box
      sx={{ bgcolor: colors.card }}
      className="px-4 py-2 rounded-lg backdrop-blur-md"
    >
      <Typography variant="h4" className="pb-2">
        {title}
      </Typography>
      <Divider />
      <Box className="grid grid-cols-3 pt-2 gap-2">
        <Box>
          <Typography fontWeight={500}>{t('Properties')}</Typography>
        </Box>
        <Box>
          <Typography fontWeight={500}>{t('Info Text')}</Typography>
          <SalesObjectLevelText
            text={description}
            levelId={id}
            onChange={onChange}
          />
        </Box>
        <Box>
          <Typography fontWeight={500}>{t('Images')}</Typography>
          <SalesObjectLevelImages
            images={images}
            levelId={id}
            onChange={onChange}
          />
          <Typography fontWeight={500}>{t('Documents')}</Typography>
        </Box>
      </Box>
    </Box>
  );
};
